import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "./Header";
import Footer from "./Footer";

import {
  fetchCommissionsLedger,
  selectCommissionsItems,
  selectCommissionsStatus,
  selectCommissionsError,
} from "../redux/slices/commissionsSlice";

function Commissions() {
  const dispatch = useDispatch();

  const items = useSelector(selectCommissionsItems) || [];
  const status = useSelector(selectCommissionsStatus);
  const errorMsg = useSelector(selectCommissionsError);

  const loading = status === "loading";

  useEffect(() => {
    dispatch(fetchCommissionsLedger());
  }, [dispatch]);

  const formatDate = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  // ledger field mappers (safe)
  const getLedgerId = (x) => x?.ledgerId || x?.id || x?._id || "-";
  const getAmount = (x) =>
    x?.amount ?? x?.commissionAmount ?? x?.credit ?? x?.value ?? 0;
  const getType = (x) =>
    x?.type ||
    x?.transactionType ||
    x?.entryType ||
    (x?.credit ? "CREDIT" : "DEBIT");
  const getTitle = (x) =>
    x?.title || x?.description || x?.remark || "Commission";
  const getRef = (x) =>
    x?.referenceId || x?.refId || x?.orderId || x?.paymentId || "-";
  const getDate = (x) => x?.createdAt || x?.date || x?.updatedAt;

  return (
    <>
      <Header />

      <main className="py-5">
        <section className="container">
          {errorMsg ? (
            <div className="alert alert-danger py-2">{errorMsg}</div>
          ) : null}

          {loading ? (
            <div className="d-flex justify-content-center py-5">
              <div
                className="spinner-border"
                role="status"
                aria-hidden="true"
              />
            </div>
          ) : null}

          {!loading && !items.length ? (
            <div className="card rounded-4 border border-light shadow-sm">
              <div className="card-body p-4">
                <h5 className="mb-1">No commissions found</h5>
                <p className="text-muted mb-0">
                  Your commissions ledger entries will appear here.
                </p>
              </div>
            </div>
          ) : null}

          <div className="row g-3 align-items-stretch">
            {!loading &&
              items.map((x, idx) => (
                <div className="col-lg-4 col-12" key={getLedgerId(x) + idx}>
                  <div className="bg-light p-5 h-100 rounded-4">
                    <span className="text-primary d-block text-uppercase fw-semibold ls-lg fs-6">
                      {formatDate(getDate(x))}
                    </span>

                    <h3 className="mb-0 lh-sm fw-semibold">{getTitle(x)}</h3>

                    <p className="fs-5 text-dark mb-0 lh-sm ls-sm">
                      Type &mdash; {getType(x)}
                      <br />
                      Amount &mdash; {getAmount(x)}
                      <br />
                      Ref. ID &mdash; {getRef(x)}
                      <hr />
                      Ledger ID &mdash; {getLedgerId(x)}
                    </p>
                  </div>
                </div>
              ))}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default Commissions;
